export default __webpack_public_path__ + "static/media/selected_tractor_charging.5136c5c0.svg";